import { Palette, getDangerColors, getNoneColors, getSuccessColors, getWarningColors } from 'Features/StationsNew/Datasources/Components/Statuses/utils';
import { DangerMode, DataReceived, EnabledMode, SoftRelease, StormMode } from 'Services/generated/datasourceStatuses.gen';

export const SUCCESS_COLORS = getSuccessColors(0.7);
export const WARNING_COLORS = getWarningColors(0.7);
export const DANGER_COLORS = getDangerColors(0.7);
export const NONE_COLORS = getNoneColors(0.7);

export const MapFilterOptions = {
  MODE: 'Режим источника',
  ENABLE: 'Активность источника',
  DATA_RECEIVED: 'Статус поступления данных',
  PHENOMENON: 'Природные явления',
  COMMON_METEOCODES: 'Общие измерения',
  METEOCODE: 'Измерение',
};

export const mapMeteocodeDataColors = ['rgba(255, 82, 82, 0.7)', 'rgba(56, 142, 60, 0.7)', 'rgba(25, 118, 210, 0.7)', 'rgb(69, 90, 100, 0.7)', 'rgb(0, 121, 107, 0.7)', 'rgb(81, 45, 168, 0.7)'];
export const mapCommonMeteocodes = [
  'TA_PROC=AVE_T=10M_Z=2M',
  'WS_PROC=AVE_T=10M_TYPE=0_Z=10M',
  'WD_PROC=AVE_T=10M_TYPE=0_Z=10M',
  'RH_PROC=AVE_T=10M_Z=2M',
  'AP_PROC=AVE_T=10M_Z=STN',
];
export type SelectedMapFilter = keyof typeof MapFilterOptions

export const DATASOURCE_FILTER_STATUSES = {
  GOOD: 'good',
  BAD: 'bad',
  WARNING: 'warning',
  NONE: 'none',
};

const defaultValue = {
  status: DATASOURCE_FILTER_STATUSES.NONE,
  hasBadStatus: false,
};

export const getStatusByDatasourceStormMode = (stormMode: StormMode) => {
  const value = { ...defaultValue };
  if (!stormMode || !stormMode.vocModeId) return value;
  if (stormMode.vocModeId === 1) value.status = DATASOURCE_FILTER_STATUSES.GOOD;
  else {
    value.status = DATASOURCE_FILTER_STATUSES.BAD;
    value.hasBadStatus = true;
  }
  return value;
};

export const getStatusByDtasourceSoftRelease = (softRelease: SoftRelease) => {
  const value = { ...defaultValue };
  if (!softRelease || !softRelease.releaseId) return value;
  if (softRelease.isActual) {
    value.status = DATASOURCE_FILTER_STATUSES.GOOD;
  } else {
    value.status = DATASOURCE_FILTER_STATUSES.GOOD;
    value.hasBadStatus = true;
  }
  return value;
};

export const getStatusByDatasourceEnableMode = (enableMode: EnabledMode) => {
  const value = { ...defaultValue };
  if (enableMode?.enabled === null) return value;
  if (enableMode.enabled) {
    value.status = DATASOURCE_FILTER_STATUSES.GOOD;
  } else {
    value.status = DATASOURCE_FILTER_STATUSES.BAD;
    value.hasBadStatus = true;
  }
  return value;
};

export const getStatusByDatasourceDataReceived = (dataRecieved: DataReceived) => {
  const value = { ...defaultValue };
  if (!dataRecieved || !dataRecieved.dataReceived) return value;
  if (dataRecieved.dataReceived === 'ALL') {
    value.status = DATASOURCE_FILTER_STATUSES.GOOD;
    return value;
  }
  if (dataRecieved.dataReceived === 'PART') {
    value.status = DATASOURCE_FILTER_STATUSES.WARNING;
    value.hasBadStatus = true;
    return value;
  }
  if (dataRecieved.dataReceived === 'NONE') {
    value.status = DATASOURCE_FILTER_STATUSES.BAD;
    value.hasBadStatus = true;
  }
  return value;
};

export const getStatusByDatasourceDangerMode = (dangerMode: DangerMode) => {
  const value = { ...defaultValue };
  if (dangerMode?.isDanger === null) return value;
  if (!dangerMode.isDanger) {
    value.status = DATASOURCE_FILTER_STATUSES.GOOD;
  } else {
    value.status = DATASOURCE_FILTER_STATUSES.BAD;
    value.hasBadStatus = true;
  }
  return value;
};

export const getColor = ({ palette, index, arrayLength, isEvenArray }: {
  palette: Palette,
  index: number,
  arrayLength: number,
  isEvenArray: boolean
}) => {
  let color = isEvenArray ? palette.ADDITIONAL_1 : palette.ADDITIONAL_2;
  if (arrayLength - 1 !== index) {
    color = index % 2 === 0 ? palette.MAIN : palette.ADDITIONAL_1;
  }
  return color;
};
